import { queryOptions } from "@tanstack/react-query";
import { fetchOccPageData } from "./pageDataClient";
import { pageDataKeys } from "./pageDataKeys";
import type { PageInitialDataResult } from "./pageInitialDataTypes";
import type { ManageUsersPageInitialData, ManageUsersSearch } from "./manageUsersPageInitialData";

const OCC_PATH = "/page-data/my-company/organization-management/manage-users";

function buildPath(search: ManageUsersSearch): string {
  const params = new URLSearchParams({
    page: String(search.page),
    show: search.show,
    sort: search.sort,
  });
  return `${OCC_PATH}?${params}`;
}

export const manageUsersPageQueryOptions = (search: ManageUsersSearch) =>
  queryOptions({
    queryKey: [...pageDataKeys.page(OCC_PATH), search],
    queryFn: () => fetchOccPageData<PageInitialDataResult<ManageUsersPageInitialData>>(buildPath(search)),
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: false,
    retry: 1,
  });
